import { render } from "./IndexPaymentCenterPaymentConfirmation.vue?vue&type=template&id=af531912"
import script from "./IndexPaymentCenterPaymentConfirmation.vue?vue&type=script&lang=js"
export * from "./IndexPaymentCenterPaymentConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__